import routes from '@/modules/document-series-allocation/document-series-allocation-routes';
import store from '@/modules/document-series-allocation/document-series-allocation-store';

export default {
    routes,
    store,
}
